export default __webpack_public_path__ + "static/media/emed-screen-logo.574326a5.svg";